import React from 'react';
import SingleConfigFieldOptions from '../../_partials/WidgetEditControls/SingleConfigFieldOptions';
import ConfigPopover from '../../_partials/ConfigPopover';

export interface Props {
  moduleId: number;
  onClose(): void;
}

export const GroupsConfigPopover: React.SFC<Props> = props => {
  return (
    <ConfigPopover withPaddings={false} onClose={props.onClose} width={230}>
      <SingleConfigFieldOptions
        moduleId={props.moduleId}
        paramName="sortBy"
        labels={{
          newest: 'common.sortOrder.newest',
          oldest: 'common.sortOrder.oldest',
          most_members: 'common.sortOrder.members',
          random: 'common.sortOrder.random',
        }}
        close={props.onClose}
      />
    </ConfigPopover>
  );
};
GroupsConfigPopover.displayName = 'GroupsConfigPopover';

export default GroupsConfigPopover;
